import { ChevronDown } from 'lucide-react';
import { useT, type Locale } from '@/lib/i18n';
import { cn } from '@/lib/utils';

const LOCALES: { value: Locale; label: string }[] = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'English' },
];

export function LangSelect({ className }: { className?: string }) {
  const { locale, setLocale, t } = useT();

  return (
    <div className={cn('relative inline-flex min-w-38', className)}>
      <select
        title={t('header.lang')}
        aria-label={t('header.lang')}
        value={locale}
        onChange={e => setLocale(e.target.value as Locale)}
        className="w-full cursor-pointer appearance-none rounded-lg border border-slate-200 bg-white py-2 pl-3 pr-9 text-center text-sm font-medium text-ink-900 shadow-xs transition focus:border-brand-400 focus:outline-hidden focus:ring-2 focus:ring-brand-200 dark:border-border/50 dark:bg-background/50 dark:text-foreground dark:focus:border-brand-500/50 dark:focus:ring-brand-500/20"
      >
        {LOCALES.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400 dark:text-muted-foreground"
        aria-hidden
      />
    </div>
  );
}
